import { useEffect, useState } from "react";

type Countdown = {
	days: number;
	hours: number;
	minutes: number;
	seconds: number;
};

export const useCountdown = (targetDateISO: string): Countdown => {
	const calculateTimeLeft = (): Countdown => {
		const difference = +new Date(targetDateISO) - +new Date();

		if (difference <= 0) {
			return { days: 0, hours: 0, minutes: 0, seconds: 0 };
		}

		const days = Math.floor(difference / (1000 * 60 * 60 * 24));
		const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
		const minutes = Math.floor((difference / 1000 / 60) % 60);
		const seconds = Math.floor((difference / 1000) % 60);

		return { days, hours, minutes, seconds };
	};

	const [countdown, setCountdown] = useState<Countdown>(calculateTimeLeft());

	useEffect(() => {
		const interval = setInterval(() => {
			setCountdown(calculateTimeLeft());
		}, 1000);

		return () => clearInterval(interval);
	}, [targetDateISO]);

	return countdown;
};
